(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('mm-use-cases')) return;

  class ModMossUseCases extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('[data-mm-use-track]');
      this.cards = Array.from(this.querySelectorAll('[data-mm-use-card]'));
      this.previous = this.querySelector('[data-mm-use-prev]');
      this.next = this.querySelector('[data-mm-use-next]');
      this.controls = this.querySelector('[data-mm-use-controls]');
      this.status = this.querySelector('[data-mm-use-status]');
      if (!this.track || !this.cards.length || !this.previous || !this.next || !this.controls || !this.status) return;
      this.events = new AbortController();
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
      this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
      this.track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(() => this.updatePosition());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || event.target !== this.track) return;
        const rtl = window.getComputedStyle(this.track).direction === 'rtl';
        let destination;
        if (event.key === 'ArrowRight') destination = this.index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') destination = this.index + (rtl ? 1 : -1);
        if (event.key === 'Home') destination = 0;
        if (event.key === 'End') destination = this.cards.length - 1;
        if (destination === undefined) return;
        event.preventDefault();
        this.goTo(destination);
      }, options);
      this.mobile.addEventListener('change', () => this.updateMode(), options);
      window.addEventListener('resize', () => this.updatePosition(), options);
      this.updateMode();
    }

    disconnectedCallback() {
      if (this.events) this.events.abort();
      window.cancelAnimationFrame(this.frame);
      this.events = null;
    }

    updateMode() {
      const carousel = this.mobile.matches && this.cards.length > 1;
      this.controls.hidden = !carousel;
      this.track.tabIndex = carousel ? 0 : -1;
      this.track.setAttribute('role', carousel ? 'group' : 'list');
      if (carousel) {
        this.setAttribute('aria-roledescription', 'carousel');
        this.track.setAttribute('aria-label', 'Use cases. Use arrow keys, Home or End to browse.');
      } else {
        this.removeAttribute('aria-roledescription');
        this.track.removeAttribute('aria-label');
      }
      this.cards.forEach((card, index) => {
        card.setAttribute('role', carousel ? 'group' : 'listitem');
        if (carousel) {
          card.setAttribute('aria-roledescription', 'slide');
          // Preserve the visible title as part of the slide's accessible name.
          card.setAttribute('aria-label', (index + 1) + ' of ' + this.cards.length + ': ' + card.dataset.mmUseTitle);
          card.dataset.mmLabelledby = card.getAttribute('aria-labelledby') || card.dataset.mmLabelledby || '';
          card.removeAttribute('aria-labelledby');
        } else {
          card.removeAttribute('aria-roledescription');
          card.removeAttribute('aria-label');
          if (card.dataset.mmLabelledby) card.setAttribute('aria-labelledby', card.dataset.mmLabelledby);
        }
      });
      this.updatePosition();
    }

    updatePosition() {
      if (!this.isConnected || !this.mobile.matches) return;
      const rtl = window.getComputedStyle(this.track).direction === 'rtl';
      const edge = rtl ? 'right' : 'left';
      const start = this.track.getBoundingClientRect()[edge];
      let distance = Infinity;
      this.cards.forEach((card, index) => {
        const offset = Math.abs(card.getBoundingClientRect()[edge] - start);
        if (offset < distance) { distance = offset; this.index = index; }
      });
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.cards.length - 1;
      const label = (this.index + 1) + ' of ' + this.cards.length;
      if (this.status.textContent !== label) this.status.textContent = label;
    }

    goTo(index) {
      if (!this.mobile.matches) return;
      const destination = Math.max(0, Math.min(this.cards.length - 1, index));
      const edge = window.getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
      const offset = this.cards[destination].getBoundingClientRect()[edge] - this.track.getBoundingClientRect()[edge];
      this.track.scrollBy({ left: offset, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
  }

  window.customElements.define('mm-use-cases', ModMossUseCases);
})();
